import { render, staticRenderFns } from "./AgendadorRelatoriosEdit.vue?vue&type=template&id=c3319538&"
import script from "./AgendadorRelatoriosEdit.vue?vue&type=script&lang=js&"
export * from "./AgendadorRelatoriosEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports